import React, { useEffect, useState } from "react"
import { Avatar, Card, Col, Radio, Row, Spin, Tooltip } from "antd"
import "./style.css"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { FaCalendarAlt, FaChevronLeft } from "react-icons/fa"
import useWindowSize from "../../../../config/hooks/utility/useWindowSize"
import { FaStar } from "react-icons/fa"
import { FaStarHalf } from "react-icons/fa"
import { FaPhoneAlt } from "react-icons/fa"
import Button from "../../../../components/FormElements/Button"
import { CiGlobe } from "react-icons/ci"
import { LuMapPin } from "react-icons/lu"
import { MdMyLocation } from "react-icons/md"
import {
  getAllServices,
  getBookingStatus,
  getCurrentLocation,
  getFormattedDateTime,
  getInitials,
  getLastLayerServices,
  getServicesList,
  getValidUrl,
} from "../../../../config/utils"
import Modal from "../../../../components/Modal"
import successCheck from "../../../../assets/images/check.png"
import masterCardIcon from "../../../../assets/images/mastercard.png"
import visaCardIcon from "../../../../assets/images/visa.png"
import { useDispatch, useSelector } from "react-redux"
import useQuoteApi from "../../../../config/hooks/api/booking/quote/useQuoteApi"
import { setAppLoading, setError, setMessage } from "../../../../store/common/generalSlice"
import CarRegistrationNumberPlate from "../../../../components/Elements/CarRegistrationNumberPlate"
import { bookingStatusDetails } from "../../../../config/utils/constants"
import LocationPicker from "../../../../components/LocationPicker"
import { LoadingOutlined } from "@ant-design/icons"
import { cardImageSelector } from "../../../../config/utils/CardImageSelector"
import ChatModal from "../../Chats/ChatModal"
import { useMutation } from "react-query"
import axiosInstance from "../../../../config/api"
import { fetchCards } from "../../../../store/common/paymentSlice"

// OPTIMIZATION: Moved static data outside component to prevent recreation on each render
const quoteDecisions = [
  {
    id: 1,
    label: "Accept",
    color: "#02B563",
  },
  {
    id: 2,
    label: "Reject",
    color: "#FF1D6A",
  },
]

const QuoteDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const { loggedInUser } = useSelector((state) => state?.auth)
  const { errorData } = useSelector((state) => state?.general)

  const { quoteId } = useParams()
  const { width } = useWindowSize()

  const { getQuoteDetails, createQuote, acceptRejectQuote } = useQuoteApi()

  const [quoteDetails, setQuoteDetails] = useState(null)
  const [quoteConfirm, setQuoteConfirm] = useState(false)
  // OPTIMIZATION: Removed unused state variables to clean up code and prevent potential memory issues
  // const [currentLocation, setCurrentLocation] = useState('')
  const [showSPQuoteSuccessAlert, setShowSPQuoteSuccessAlert] = useState(false)
  // const [showRejectionConfirm, setShowRejectionConfirm] = useState(false)
  // const [showActions, setShowActions] = useState(false)
  const [userLocation, setUserLocation] = useState(null)
  // const [refresh, setRefresh] = useState(0)
  const [showQuoteForm, setShowQuoteForm] = useState(false)
  // const [quoteRejectionDetails, setQuoteRejectionDetails] = useState(null)
  const [showLocationPicker, setShowLocationPicker] = useState(false)
  const [spServices, setSpServices] = useState([])

  const quoteStatus = bookingStatusDetails

  const user = useSelector((state) => state?.auth?.loggedInUser)

  const getQuoteDetailsRequest = async (quoteId) => {
    try {
      dispatch(setAppLoading(true))

      const response = await getQuoteDetails(quoteId)
      if (response) {
        const data = { ...(response?.data?.quoteDetails || response?.data?.quote) }
        if (Object.keys(data).length) {
          const idx = quoteStatus?.findIndex((e) => e.label?.toLowerCase() == data?.status.toLowerCase())
          if (idx > -1) {
            data.status = idx
          }
        }
        setQuoteDetails(data);
        const spServicesArr = response?.data?.quote?.user?.services || response?.data?.quoteDetails?.user?.services
        if (spServicesArr?.length > 0) {
          setSpServices(() => {
            return spServicesArr?.filter(service => service?.parentId == null)
          })
        }
      }
    } catch (error) {
      // OPTIMIZATION: Improved error handling with proper error logging and user feedback
      console.error("Error fetching quote details:", error)
      dispatch(setError("Failed to load quote details"))
    } finally {
      // OPTIMIZATION: Added finally block to ensure loading state is always reset
      dispatch(setAppLoading(false))
    }
  }

  const handleQuoteBySP = async (decisionId) => {
    if (decisionId == 1) {
      // OPTIMIZATION: Removed unnecessary setTimeout that was artificially delaying state updates
      setQuoteConfirm(true)
    }
  }

  const handlePaymentConfirm = async (status, cardNumber) => {
    try {
      dispatch(setAppLoading(true))

      const { lat: latitude, lng: longitude, address } = userLocation
      const response = await acceptRejectQuote({
        action: "Accept",
        bookingId: quoteDetails?.bookingId,
        quoteId: quoteDetails.id,
        latitude,
        longitude,
        address,
        paymentMethodId: cardNumber,
      })
      if (response) {
        setShowSPQuoteSuccessAlert(true)
        setQuoteConfirm(false)
        setTimeout(() => {
          navigate("/booking/my-bookings")
        }, 2000)

        dispatch(setAppLoading(false))
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }

  const bookingFormDataOrStatusHandler = async (data) => {
    try {
      dispatch(setAppLoading(true))

      const temp = structuredClone(data)
      const payload = {
        ...temp?.fetchedVehicleData,
        ...temp?.location,
        serviceProviderId: quoteDetails?.serviceProvider,
        quote: false,
        ...temp,
      }
      payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
      // payload.services = [].concat(...Object.values(temp?.services))
      // payload.services = [18,19,20] //dev env
      // payload.services = [77,80,83] //QA env
      payload.year = payload.year + ""

      const keysToDelete = [
        "vehicleRegistrationNumber",
        "id",
        "createdAt",
        "carRegNo",
        "isApproved",
        "status",
        "updatedAt",
        "forgot",
        "fetchedVehicleData",
        "location",
        "userId",
      ]
      for (let i = 0; i < keysToDelete.length; i++) {
        delete payload[keysToDelete[i]]
      }

      const response = await createQuote(payload)
      if (response) {
        dispatch(setAppLoading(false))

        dispatch(setMessage(response?.data?.message))
        navigate("/quote/my-quotes")
      }
    } catch (error) {
      console.log(error)
      dispatch(setAppLoading(false))
    }
  }

  const handleBack = () => {
    if (showQuoteForm) setShowQuoteForm(false)
    else navigate("/")
  }

  const handleSelectedLocation = (selectedCoordinatesPreview, selectedLocationPreview) => {
    if (selectedLocationPreview && selectedCoordinatesPreview) {
      const { lat, lng } = selectedCoordinatesPreview
      setUserLocation({ address: selectedLocationPreview, lat, lng })
      setShowLocationPicker(false)
    }
  }

  // OPTIMIZATION: Properly structured async function in useEffect with async IIFE pattern
  useEffect(() => {
    const fetchUserLocation = async () => {
      const userLocation = await getCurrentLocation()
      setUserLocation(userLocation)
    }
    fetchUserLocation()
  }, [])

  useEffect(() => {
    if (quoteId) getQuoteDetailsRequest(quoteId)
  }, [quoteId]) // OPTIMIZATION: Removed unnecessary 'refresh' dependency to prevent extra renders

  useEffect(() => {
    if (quoteDetails) {
      if (getBookingStatus(quoteDetails?.status) == "pending") {
        // setShowActions(true)
      }
    }
  }, [quoteDetails])

  useEffect(() => {
    //SP to SP booking does not have qoute section that's why it redirect to mybooking, mybooking have qoutes init
    if (errorData?.data?.error?.message?.toLowerCase().includes("quote not found for the given id.")) {
      setTimeout(() => {
        navigate(`../booking/${quoteId}`)
      }, 2000)
    }
  }, [errorData])

  // OPTIMIZATION: Added cleanup for timers to prevent memory leaks
  useEffect(() => {
    let timer
    if (showSPQuoteSuccessAlert) {
      timer = setTimeout(() => {
        navigate("/booking/my-bookings")
      }, 2000)
    }
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [showSPQuoteSuccessAlert, navigate])

  return (
    <React.Fragment>
      <Row>
        <Col span={24} className={`sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}>
          <div className="flex justify-between items-center">
            <h5 className="heading-5 text-slate-600 font-semibold">Details</h5>
            <div onClick={handleBack} className="cursor-pointer flex items-center">
              <FaChevronLeft className="text-primary bg-white p-2 rounded-full text-3xl" />
              <small className="ml-2 font-medium">Back</small>
            </div>
          </div>
        </Col>
        <Col
          span={24}
          className={`
                        sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6`}
        >
          {quoteDetails && Object.keys(quoteDetails).length ? (
            <Card bordered={false} className="mb-4 rounded-md">
              <div className="flex sm:flex-row flex-col">
                <div className="flex justify-center">
                  <Avatar
                    className="border-2 p-1 mb-2 border-primary rounded-full"
                    src={
                      pathname.includes("price-proposal")
                        ? quoteDetails?.booking?.serviceUser?.imageThumbUrl
                        : quoteDetails?.user?.imageThumbUrl
                    }
                    alt="avatar"
                    size={width > 767 ? 100 : 120}
                  >
                    {getInitials(
                      pathname.includes("price-proposal")
                        ? quoteDetails?.booking?.serviceUser?.fullName
                        : quoteDetails?.user?.userDetail?.businessName
                    )}
                  </Avatar>
                </div>
                <div className="flex sm:flex-row flex-col sm:items-center sm:justify-between sm:ml-2 ml-0 w-full">
                  <div className="flex flex-col justify-center ml-1">
                    <div className="flex flex-col sm:flex-row sm:justify-between justify-center items-center">
                      <div className="flex mr-2">
                        <div className="sm:mr-2">
                          <h3 className="heading-3 font-bold mb-2 whitespace-nowrap">
                            {pathname.includes("price-proposal")
                              ? quoteDetails?.booking?.serviceUser?.fullName
                              : quoteDetails?.user?.userDetail?.businessName}
                          </h3>
                        </div>

                        {quoteDetails?.user?.badges && quoteDetails?.user?.badges.length ? (
                          <div className="flex items-center mb-2 sm:w-[50px]">
                            {quoteDetails?.user?.badges.map((badge) => (
                              <img
                                key={badge?.id}
                                src={badge?.imageUrl || "/placeholder.svg"}
                                alt={badge?.name}
                                className="img-fluid mr-2 badge"
                                onError={(e) => { e.target.style.display = 'none' }}
                              />
                            ))}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {getBookingStatus(quoteDetails?.status) == "in-progress" && (
                        <div className="flex items-center justify-center border rounded-md px-2 py-1 border-[#1677ff] sm:w-2/7 w-2/7 h-[25px]">
                          <span className="text-[#1677ff] text-xs">In-Progress</span>
                        </div>
                      )}
                    </div>

                    <React.Fragment>
                      {/* previous work */}
                      {/* <div className='sm:flex hidden sm:items-start sm:justify-start justify-center'>
                                                {
                                                    quoteDetails?.services &&
                                                        quoteDetails?.services.length ?
                                                        quoteDetails?.services.slice(0, 3).map((service, index) => (
                                                            <span key={index}>
                                                                <p className='text-gray-500 font-semibold text-xs mb-3' >
                                                                    {service?.name}

                                                                    {index < quoteDetails?.services.slice(0, 3).length - 1 &&
                                                                        (<span className='mx-1'>|</span>)}
                                                                    {index == 2 && quoteDetails?.services.length > 3 ?
                                                                        (<span className='mr-1'>...</span>) : ''}
                                                                </p>
                                                            </span>
                                                        )) : (
                                                            <small className='text-xs mb-3'>Services not available</small>
                                                        )
                                                }
                                            </div> */}

                      {/* updated work */}
                      {/* <div className="flex justify-center sm:justify-start">
                        {quoteDetails?.selectedCategories && quoteDetails?.selectedCategories?.length > 0 ? (
                          <React.Fragment>
                            {quoteDetails?.selectedCategories[0].subServices?.length > 0 ? (
                              <span className="flex gap-1 items-center">
                                <p className="text-gray-500 font-semibold text-xs mb-3">
                                  {quoteDetails?.selectedCategories[0].name + ","}
                                </p>
                                <p className="text-gray-500 font-semibold text-xs mb-3">
                                  {quoteDetails?.selectedCategories[0].subServices[0]?.name + " ..."}{" "}
                                </p>
                              </span>
                            ) : (
                              <p>-</p>
                            )}
                            {quoteDetails?.selectedCategories?.length > 0 &&
                            quoteDetails?.selectedCategories[0]?.subServices?.length > 0 &&
                            quoteDetails?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0 ? (
                              <Tooltip
                                title={getServicesList(
                                  quoteDetails?.selectedCategories[0]?.subServices[0]?.subServices,
                                  true,
                                )}
                              >
                                <p className="text-xs ml-2 cursor-pointer">show all</p>
                              </Tooltip>
                            ) : (
                              ""
                            )}
                          </React.Fragment>
                        ) : (
                          <small className="text-xs">Services not available</small>
                        )}
                      </div> */}
                      <div className='flex justify-start mt-2'>
                        {
                          quoteDetails?.services &&
                            spServices?.length > 0 ? (
                            <React.Fragment>
                              {
                                spServices.slice(0, 3)?.map((service) => {
                                  if (service?.name) {
                                    return (
                                      <span className='flex gap-1 items-center justify-start'>
                                        <p className='text-gray-500 font-semibold text-xs mb-3 w-fit'>
                                          {service?.name + ','}
                                        </p>
                                      </span>
                                    )
                                  }
                                })
                              }
                              {spServices?.length > 3 && <span>...</span>}
                              {spServices?.length > 3 &&
                                (
                                  <Tooltip title={getServicesList(spServices, false)}>
                                    <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                  </Tooltip>
                                )}
                            </React.Fragment>
                          ) : (
                            <small className='text-xs'>Services not available</small>
                          )
                        }
                      </div>

                      {user?.type.toLowerCase() == "service user" ? (
                        <div className="flex mb-4 sm:justify-start justify-center">
                          <small className="mr-6 text-[#00B517] font-semibold">
                            {`${quoteDetails?.serviceProvider?.noOfBookingCompleted ?? 0} Job(s) Completed`}
                          </small>
                          <small className="text-[#FF1D6A] font-semibold">
                            ({" "}
                            {quoteDetails?.user?.distance
                              ? quoteDetails?.user?.distance?.toFixed(2) + " Miles Away"
                              : 0 + " Miles Away"}{" "}
                            )
                          </small>
                        </div>
                      ) : (
                        ""
                      )}
                    </React.Fragment>

                    <div className="flex sm:flex-row flex-col pl-0">
                      {user?.type.toLowerCase() == "service user" && quoteDetails?.user?.averageRating !== undefined ? (
                        <React.Fragment>
                          <div className="ratings sm:mr-2 mr-0 mb-2 bg-slate-100 flex rounded-md items-center justify-center items-center p-2 ">
                            <span className="mr-2 font-bold">{Math.floor(quoteDetails?.user?.averageRating)}/5</span>
                            {/* rated stars count */}
                            {Array(Math.floor(quoteDetails?.user?.averageRating))
                              .fill(0)
                              .map((el, index) => (
                                <FaStar key={index} className="text-primary" />
                              ))}
                            {quoteDetails?.user?.ratingCount - Math.floor(quoteDetails?.user?.ratingCount) != 0 && (
                              <FaStarHalf className="text-primary" />
                            )}

                            {/* unrated stars count */}
                            {Array(5 - Math.floor(quoteDetails?.user?.averageRating))
                              .fill(0)
                              .map((el, index) => (
                                <FaStar key={index} className="text-gray-400" />
                              ))}
                          </div>
                          {/* <div className="bg-[#FEEDBF] sm:mr-2 mr-0 mb-2 p-2 rounded-md">
                            <Link to={`tel:${quoteDetails?.user?.phoneNo}`} className="block h-full">
                              <div className="flex justify-center items-center h-full">
                                <FaPhoneAlt className="text-3xl text-white bg-primary p-[5px] rounded-full" />
                                <small className="text-xs ml-2">Call</small>
                              </div>
                            </Link>
                          </div> */}
                          <div className="sm:mr-2 mr-0 mb-2 p-2 bg-[#feedbf] text-xs rounded-md">
                            <ChatModal selectedChatMemberData={quoteDetails?.user} />
                          </div>
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {user?.type.toLowerCase() == "service provider" ? (
                    <div className="mb-4 flex sm:justify-end justify-center sm:w-fit w-full">
                      <div>
                        <CarRegistrationNumberPlate regNumber={quoteDetails?.booking?.vehicleRegistrationNo} />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="border-dashed border-1 border-gray-200 mb-3" />
              <div>
                <div className="flex sm:flex-row flex-col mb-3">
                  {quoteDetails?.address && (
                    <div className="flex mr-4 items-center sm:mb-0 mb-2">
                      <div className="w-[20px] mr-2">
                        <LuMapPin className="text-2xl text-white bg-primary p-[3px] rounded-full" />
                      </div>
                      <small className="text-xs font-md">
                        {pathname.includes("price-proposal") ? quoteDetails?.booking?.address : quoteDetails?.address}
                      </small>
                    </div>
                  )}
                  {/* {(pathname.includes("price-proposal")
                    ? quoteDetails?.booking?.serviceUser?.phoneNo
                    : quoteDetails?.user?.phoneNo) && (
                      <div className="flex mr-4 items-center sm:mb-0 mb-2">
                        <Link
                          to={`tel:${pathname.includes("price-proposal")
                            ? quoteDetails?.booking?.serviceUser?.phoneNo
                            : quoteDetails?.user?.phoneNo
                            }`}
                          className="flex h-full items-center"
                        >
                          <div className="w-[20px] mr-2">
                            <FaPhoneAlt className="text-2xl text-white p-[4px] rounded-full bg-[#3879f0]" />
                          </div>
                          <small className="text-xs font-md">
                            {pathname.includes("price-proposal")
                              ? quoteDetails?.booking?.serviceUser?.phoneNo
                              : quoteDetails?.user?.phoneNo}
                          </small>
                        </Link>
                      </div>
                    )} */}
                  {quoteDetails?.website && (
                    <div className="flex items-center sm:mb-0 mb-2 w-full sm:w-1/6">
                      <a
                        href={getValidUrl(quoteDetails?.website)}
                        target="_blank"
                        className="flex h-full items-center"
                        rel="noreferrer"
                      >
                        <div className="w-[20px] mr-2">
                          <CiGlobe className="text-2xl text-white p-[4px] rounded-full bg-[#00b517]" />
                        </div>
                        <small className="text-xs font-md">{quoteDetails?.website}</small>
                      </a>
                    </div>
                  )}
                  {quoteDetails?.quotes && quoteDetails?.quotes.length && quoteDetails?.quotes[0]?.date ? (
                    <div className="flex items-center sm:mb-0 mb-2 w-full sm:w-1/6">
                      <div className="w-[30px] mr-2">
                        <FaCalendarAlt className="bg-[#fa3434] text-xl text-white p-[3px] rounded-full" />
                      </div>
                      <small className="text-xs font-md">
                        {getFormattedDateTime(
                          `${quoteDetails?.quotes[0]?.date}T${quoteDetails?.quotes[0]?.time}`,
                          "DD-MM-YYYY HH:mm",
                        )}
                      </small>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {/* <hr className='border-dashed border-1 border-gray-200 mb-4' /> */}

                {/* <div className='mb-4'>
                                    <h6 className='heading-6 font-bold text-sm mb-4'>Services Requested:</h6>
                                    <div className='flex sm:flex-row flex-col'>
                                        {
                                            quoteDetails?.services &&
                                                quoteDetails.services.length ? (
                                                <React.Fragment>
                                                    {
                                                        quoteDetails?.services.slice(0, 3).map((service, index) => (
                                                            <div className='flex items-center mr-2 mb-2' key={index}>
                                                                <div className='w-[20px]'>
                                                                    <FaCircleCheck className='text-md text-[#FAB700] bg-white rounded-full mr-2' />
                                                                </div>
                                                                <small className='font-md text-xs'>{service?.name}</small>
                                                            </div>
                                                        ))
                                                    }
                                                    {quoteDetails?.services?.length > 3 ? (
                                                        <Tooltip title={getServicesList(quoteDetails?.services)}>
                                                            <p className='text-xs sm:ml-2 mt-[2px] cursor-pointer'>show all</p>
                                                        </Tooltip>
                                                    ) : ''}
                                                </React.Fragment>
                                            ) : (
                                                <small className='text-xs'>Services not available</small>
                                            )
                                        }
                                    </div>
                                </div> */}

                <hr className="border-dashed border-1 border-gray-200 mb-4" />

                {/* {quoteDetails?.selectedCategories && (
                  <div className="mt-4">
                    {quoteDetails?.selectedCategories?.length > 0 ? (
                      getAllServices(quoteDetails?.selectedCategories)
                    ) : (
                      <small className="text-xs">Services not available</small>
                    )}
                  </div>
                )} */}

                <div className='mt-4 mb-5'>
                  {quoteDetails?.services?.length > 0 ?
                    getLastLayerServices(quoteDetails?.services)
                    :
                    <small className='text-xs'>Services not available</small>
                  }
                </div>

                {quoteDetails && quoteDetails?.details && (
                  <div className="mb-4">
                    <h6 className="heading-6 font-bold text-sm mb-2">Additional Info/Note</h6>
                    <small className="text-xs font-md">{quoteDetails?.details}</small>
                  </div>
                )}

                {!quoteConfirm &&
                  getBookingStatus(quoteDetails?.status) == "responded" &&
                  quoteDetails?.quotes.length && (
                    <div className="bg-blue-500 p-2 w-full mb-4 rounded-md">
                      <small className="text-white">
                        {`${quoteDetails?.user?.fullName} has
                                                updated your quote No. ${quoteDetails?.id} quoted price
                                                £${quoteDetails?.quotes[0].price} 
                                                ${quoteDetails?.quotes[0].vatIncluded ? "(Prices include VAT where applicable)." : ""}  
                                            `}
                      </small>
                    </div>
                  )}

                {/* case: pending */}
                {/* su accepts/rejects quote sent by sp */}
                {!quoteConfirm &&
                  getBookingStatus(quoteDetails?.status) == "responded" &&
                  quoteDetails?.quotes &&
                  quoteDetails?.quotes.length ? (
                  <div className="flex mb-4">
                    {quoteDecisions.map((decision) => (
                      <div
                        key={decision?.id}
                        onClick={() => handleQuoteBySP(decision?.id)}
                        className={`sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
                        style={{
                          backgroundColor: decision?.color,
                        }}
                      >
                        {decision?.label}
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )}

                {quoteDetails?.reasonOfRejection && getBookingStatus(quoteDetails?.status) == "rejected" && (
                  <div>
                    <h6 className="heading-6 font-bold text-sm mb-2">Rejection Reason</h6>
                    <small className="text-xs font-md">{quoteDetails?.reasonOfRejection}</small>
                  </div>
                )}

                {quoteDetails?.booking?.userId === loggedInUser?.id &&
                  getBookingStatus(quoteDetails?.status) === "pending" && (
                    <React.Fragment>
                      {/* {quoteDetails?.serviceProviderId && (
                        <div className="mb-4">
                          <h6 className="heading-6 font-bold text-sm">Quote Location:</h6>
                          <div className="bg-slate-100 flex justify-between items-center rounded-md w-full p-4">
                            <small className="text-xs">{userLocation?.address}</small>
                            <div className="w-[20px] cursor-pointer">
                              <MdMyLocation className="text-primary" onClick={() => setShowLocationPicker(true)} />
                            </div>
                          </div>
                        </div>
                      )} */}
                      <div className="bg-slate-100">
                        <PaymentDetails data={quoteDetails} onSuccess={handlePaymentConfirm} />
                      </div>
                    </React.Fragment>
                  )}
              </div>
            </Card>
          ) : (
            <div className="w-full flex flex-col items-center">
              <h5 className="heading-5 font-bold">Quote not found</h5>
            </div>
          )}

          <Modal.Basic
            open={showSPQuoteSuccessAlert}
            onCancel={() => setShowSPQuoteSuccessAlert(false)}
            width={300}
            maskClosable={false}
          >
            <Alert
              onSuccess={() => setShowSPQuoteSuccessAlert(false)}
              onCancel={() => setShowSPQuoteSuccessAlert(false)}
            />
          </Modal.Basic>

          {showLocationPicker ? (
            <div className="w-[300px]">
              <LocationPicker
                addressPicker={handleSelectedLocation}
                hideInput
                modal={showLocationPicker}
                onClose={() => setShowLocationPicker(false)}
              />
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

// OPTIMIZATION: Used React.memo to prevent unnecessary re-renders of this component
const Alert = React.memo(() => {
  return (
    <Card bordered={false} className="rounded-md">
      <div className="flex flex-col items-center">
        {/* OPTIMIZATION: Added fallback for image source to prevent broken images */}
        <img src={successCheck || "/placeholder.svg"} alt="check-success" className="img-fluid w-[200px]" />
        <h3 className="heading-3 font-bold">Thank You</h3>
        <p className="mb-2">Your message has been received and we would be contacting you shortly</p>
      </div>
    </Card>
  )
})

const PaymentDetails = ({ data, onSuccess }) => {
  const [selectedCreditCardProvider, setSelectedCreditCardProvider] = useState("")
  const [acceptBidQuote, setAcceptBidQuote] = useState(false)
  const { loading, cards, error } = useSelector((state) => state?.payments);
  const [fetchCardsTrigger, setFetchCardTrigger] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    const visibilityChangeHandler = () => {
      if (document.visibilityState == 'visible' && fetchCardsTrigger) {
        dispatch(fetchCards());
      }
    }
    document.addEventListener('visibilitychange', visibilityChangeHandler)
    return () => {
      document.removeEventListener('visibilitychange', visibilityChangeHandler);
    }
  }, [fetchCardsTrigger])

  // OPTIMIZATION: Memoized expensive calculation to prevent recalculation on every render
  const formattedDateTime = React.useMemo(() => {
    return getFormattedDateTime(`${data?.date}T${data?.time}`, "DD-MM-YYYY HH:mm")
  }, [data?.date, data?.time])


  // const form = {
  //     name: 'addCreditCardForm',
  //     formFields: [
  //         {
  //             name: 'cardHolderName',
  //             label: { value: 'Card Holder Name:', classes: '' },
  //             type: 'text',
  //             placeholder: 'Victor Niculici',
  //             width: { md: 6, sm: 6, xs: 24 },
  //             component: null,
  //             classes: '',
  //             icon: null
  //         },
  //         {
  //             name: 'cardNumber',
  //             label: { value: 'Card Number', classes: '' },
  //             type: 'text',
  //             placeholder: '4533 5555 6666 7777',
  //             width: { md: 6, sm: 6, xs: 24 },
  //             component: null,
  //             classes: '',
  //             icon: null,
  //         },
  //         {
  //             name: 'cardExpiry',
  //             label: { value: 'Expiry Date:', classes: '' },
  //             type: 'datepicker',
  //             format: 'MM/YYYY',
  //             placeholder: '10 June, 2024',
  //             width: { md: 6, sm: 6, xs: 24 },
  //             component: null,
  //             classes: 'h-[47px] w-full',
  //             icon: null
  //         },
  //         {
  //             name: 'cardCVV',
  //             label: { value: 'CVV:', classes: '' },
  //             type: 'password',
  //             placeholder: '',
  //             width: { md: 6, sm: 6, xs: 24 },
  //             component: null,
  //             classes: '',
  //             icon: null
  //         },
  //     ],
  //     formValidation: {
  //         cardHolderName: Yup.string()
  //             .required('Card holder name is required')
  //             .min(3, 'Card holder name must be at least 3 characters')
  //             .matches(/^[a-zA-Z\s]+$/, 'Card holder name should only contain letters and spaces'),

  //         cardNumber: Yup.string()
  //             .required('Card number is required')
  //             .matches(/^[0-9]{16}$/, 'Card number must be exactly 16 digits'),

  //         cardCVV: Yup.string()
  //             .required('CVV is required')
  //             .matches(/^[0-9]{3}$/, 'CVV must be exactly 3 digits'),
  //     }
  // }

  const handleCreditCardProviderSelection = (e) => {
    setSelectedCreditCardProvider(e.target.value)
  }

  const handleSubmit = (values) => {
    if (!selectedCreditCardProvider) {
      dispatch(setError("Kindly select your card to proceed"))
      return
    } else {
      onSuccess(true, selectedCreditCardProvider)
    }
  }

  // const submitForm = () => {
  //     document.querySelector('form#addCreditCardForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
  // }

  // stripe card add call.
  const cardAddMutation = useMutation(async () => {
    let res = await axiosInstance.post('/stripe/add-card', {});
    return res
  },
    {
      onSuccess: (res) => {
        dispatch(setMessage(res?.data?.data?.message))
        setFetchCardTrigger(true)
        window.open(res?.data?.data?.cardCheckoutSession, '_blank')
        dispatch(setAppLoading(false))
      },
      onError: (error) => {
        dispatch(setAppLoading(false))
        dispatch(setError(error.response?.data?.message || 'An error occured'))
      }
    }
  )

  const cardAttachHandler = () => {
    dispatch(setAppLoading(true))
    cardAddMutation.mutate()
  }

  return (
    <div className="p-4 w-full flex flex-col">
      <div>
        <h6 className="heading-6 font-semibold text-xs">Quoted Price:</h6>
        <h2 className="heading-2 font-bold">£{data?.price}</h2>
      </div>

      <hr className="border-dashed border-1 border-gray-200 mb-4" />

      <div className="mb-4">
        <h6 className="heading-6 font-semibold text-xs">Services Responded:</h6>
        <div className="flex sm:flex-row flex-col">
          {data?.services?.length > 0 ? (
            <React.Fragment>
              {data?.services?.slice(0, 3).map((service, index) => (
                <span className="inline-block mb-2" key={index}>
                  <p className="text-gray-500 font-bold">
                    {service?.name}

                    {index < data?.services?.slice(0, 3).length - 1 && (
                      <span className="sm:mx-1 mr-1">
                        <span className="sm:inline hidden">|</span>
                        <span className="sm:hidden inline">,</span>
                      </span>
                    )}
                    {index == 2 && data?.services?.length > 3 ? <span className="mr-1">...</span> : ""}
                  </p>
                </span>
              ))}
              {data?.services?.length > 3 ? (
                <Tooltip title={getServicesList(data?.services)}>
                  <p className="text-xs sm:ml-2 mt-[2px] cursor-pointer">show all</p>
                </Tooltip>
              ) : (
                ""
              )}
            </React.Fragment>
          ) : (
            <small className="text-xs">Not available</small>
          )}
        </div>
      </div>

      <hr className="border-dashed border-1 border-gray-200 mb-4" />

      <div className="mb-4">
        <h6 className="heading-6 font-semibold text-xs">Details of Service:</h6>
        <p className="text-xs font-semibold">{data?.additionalInfo}</p>
      </div>

      <hr className="border-dashed border-1 border-gray-200 mb-4" />

      <div className="mb-4">
        <h6 className="heading-6 font-semibold text-xs">Appointment - Date & Time:</h6>
        <div className="flex items-center">
          <FaCalendarAlt className="bg-[#fa3434] text-xl text-white p-[3px] rounded-full mr-2" />
          {/* OPTIMIZATION: Using memoized value instead of recalculating on every render */}
          <p className="text-xs font-semibold">{formattedDateTime}</p>
        </div>
      </div>

      {/* case: if quote then user will confirm quote from here as well to begin payment process */}
      {/* { !data?.serviceProviderId && !acceptBidQuote && ( */}
      {!acceptBidQuote && (
        <div className="flex">
          <div
            onClick={() => setAcceptBidQuote(true)}
            className={`bg-[#02b463] sm:w-fit w-full mr-2 text-xs px-6 py-3 text-white rounded-md cursor-pointer text-center`}
          >
            Accept
          </div>
        </div>
      )}

      {/* { (data?.serviceProviderId || acceptBidQuote) && ( */}
      {acceptBidQuote && (
        <React.Fragment>
          <hr className="border-dashed border-1 border-gray-200 mb-4" />

          <div className="bg-[#02b463] p-2 sm:w-3/5 w-full mb-4 rounded-sm">
            <small className="text-white text-xs">
              Payments will be disbursed only when the job is completed and closed.
            </small>
          </div>

          <div className="w-full mb-6 flex gap-2 items-center flex-wrap">
            {loading ? (
              <Spin indicator={<LoadingOutlined loading />} size="default" />
            )
              : cards && cards?.length > 0 && (
                <>
                  <Radio.Group
                    className="flex sm:flex-row flex-col gap-2 flex-wrap"
                    onChange={handleCreditCardProviderSelection}
                    value={selectedCreditCardProvider}
                  >
                    {cards?.map((card, index) => (
                      <div className={`bg-white p-2 flex justify-between w-fit mb-2 gap-5`} key={card?.id}>
                        <div className="flex flex-nowrap px-4 gap-4">
                          <div className="flex items-center">
                            <img
                              src={cardImageSelector(card?.brand) || "/placeholder.svg"}
                              alt="credit card provider icon"
                              className="img-fluid w-[50px]"
                            />
                          </div>
                          <div className="flex flex-col gap-0">
                            <h6 className="heading-6 font-bold mb-1">{card?.brand}</h6>
                            <p className="text-xs flex flex-row gap-1">
                              **** **** **** <span>{card?.last4}</span>
                            </p>
                          </div>
                        </div>
                        <Radio value={card?.id} className=""></Radio>
                      </div>
                    ))}
                  </Radio.Group>
                </>
              )
            }
            {
              !loading &&
              <div className='w-full flex flex-col gap-2'>
                {
                  cards?.length == 0 && <p>No cards attached.</p>
                }
                <Button.Basic
                  onClick={cardAttachHandler}
                  disabled={false}
                  icon={null}
                  loading={false}
                  type="primary"
                  size='medium'
                  text='add Card'
                  className='btn-primary bg-[#02B463] sm:w-fit w-full'
                />
              </div>
            }
          </div>

          <div className="flex flex-col">
            {/* <div className='mb-4'>
                            <h6 className='heading-6 font-bold mb-1'>Add New Card:</h6>
                            <small className='text-xs'>Enter your credit card details.</small>
                        </div> */}

            {/* <DynamicForm id='addCreditCardForm' form={form} onSubmit={handleSubmit} /> */}
            {
              cards && cards?.length > 0 &&
              <div className="w-full">
                <Button.Basic
                  onClick={handleSubmit}
                  disabled={false}
                  icon={null}
                  loading={false}
                  type="primary"
                  size="medium"
                  text="Confirm Payment"
                  className="btn-primary sm:w-fit w-full"
                />
              </div>
            }

          </div>
        </React.Fragment>
      )
      }
    </div >
  )
}

export default QuoteDetails
